var exports = {
  "CB": "RoleManagement.module__roleIndicator___OE1VcU",
  "KG": "RoleManagement.module__roleBadge___OE1VcU",
  "Gy": "RoleManagement.module__roleRemoveButtonContainer___OE1VcU",
  "j1": "RoleManagement.module__roleRemoveButton___OE1VcU",
  "r4": "RoleManagement.module__roleRemoveIconContainer___OE1VcU",
  "S3": "RoleManagement.module__roleName___OE1VcU",
  "MR": "RoleManagement.module__roleListContainer___OE1VcU",
  "ek": "RoleManagement.module__assignRoleButton___OE1VcU",
  "JO": "RoleManagement.module__assignRoleButtonIcon___OE1VcU",
  "RK": "RoleManagement.module__iconSize___OE1VcU",
  "Xk": "RoleManagement.module__noRolesLink___OE1VcU",
  "X9": "RoleManagement.module__roleColorIndicator___OE1VcU",
};

module.exports = exports;
